// Español (informal "tú", como la mayoría de las apps sociales).
export default {
  nav: {
    home: "Inicio",
    search: "Buscar",
    explore: "Explorar",
    messages: "Mensajes",
    tribzz: "Tribzz",
    channels: "Canales",
    settings: "Ajustes",
  },

  language: {
    title: "Idioma",
    lead: "Elige el idioma que Tribzz usa contigo. También se aplica a la app en tu teléfono.",
    note: "Las publicaciones y los mensajes se quedan en el idioma en que se escribieron. Algunas pantallas aún se están traduciendo y por ahora aparecen en inglés.",
    saved: "✓ Guardado",
    saving: "Guardando…",
    error: "No se pudo guardar. Revisa tu conexión e inténtalo de nuevo.",
    done: "Listo",
  },

  settings: {
    kicker: "Tu cuenta",
    title: "Ajustes",
    editPhoto: "Editar foto de perfil",
    member: "Miembro",
    profileComplete: "Perfil completo al {pct}%",
    quickEdit: "👤 Editar perfil",
    quickTribzz: "◆ Mis Tribzz",
    quickSecurity: "🔐 Seguridad",
    finishTitle: "Completa tu perfil",
    finishSub: "Agrega tu {fields} para que la gente sepa que eres tú.",
    gathering: "Cargando tu cuenta…",
    fields: {
      name: "nombre completo",
      image: "foto de perfil",
      email: "correo",
      phone: "teléfono",
      description: "biografía",
      more: "y {n} más",
    },
    sections: {
      account: "Cuenta",
      membership: "Membresía",
      create: "Crea y gana",
      stuff: "Tus cosas",
      community: "Comunidad y apps",
      support: "Ayuda",
    },
    rows: {
      personal: { title: "Información personal", sub: "Nombre, usuario, foto, intereses, privacidad" },
      profilePage: { title: "Tu página de perfil", sub: "Mira lo que ven los demás" },
      security: { title: "Seguridad", sub: "Contraseña e inicios de sesión recientes" },
      notifications: { title: "Notificaciones", sub: "Alertas del teléfono, correo y horas de silencio" },
      language: { title: "Idioma", sub: "El idioma que Tribzz usa contigo" },
      creator: { title: "Panel de creador", sub: "Ganancias, vistas reales, clips, lanzamientos y directos" },
      business: { title: "Herramientas de negocio", sub: "Pedidos para llevar, reservas, entradas y presupuestos para tu Tribzz" },
      pro: { title: "Tribzz Pro", sub: "Ofrece tus servicios: verifícate, que te encuentren y te contraten" },
      tickets: { title: "Mis entradas", sub: "Entradas de eventos y sus códigos QR" },
      savedShorts: { title: "Shorts guardados" },
      memories: { title: "Recuerdos" },
      invite: { title: "Invita a tus amigos", sub: "Trae a tu gente a Tribzz" },
      muzilly: { title: "Muzilly" },
      ideas: { title: "Tablero de ideas", sub: "Vota lo próximo que construirá Tribzz" },
      help: { title: "Ayuda y preguntas frecuentes", sub: "Respuestas y soporte" },
      about: { title: "Acerca de Tribzz", sub: "Versión, términos y privacidad" },
    },
    pctLeft: "Falta {n}%",
    plan: {
      admin: "Admin",
      subscriber: "◆ Suscriptor",
      free: "Miembro gratis",
    },
    membership: {
      fullAccess: "Acceso total",
      adminText: "Todas las funciones, para pruebas. No es un plan de pago, así que no hay nada que gestionar ni cancelar.",
      adminUsage: "{n} minutos en directo usados este mes · sin límite",
      perMonth: "5 $ / mes",
      usage: "{used} de {cap} minutos en directo usados este mes",
      manage: "Gestionar suscripción",
      opening: "Abriendo…",
      kicker: "◆ Membresía Tribzz",
      bigLead: "Transmite en directo, publica más,",
      bigAccent: "apoya a Tribzz.",
      perk1: "Publica más de una foto a la vez",
      perk2: "Transmite en directo y mira los directos de otros miembros",
      perk3: "Sin anuncios, y tus datos nunca se venden",
      subscribe: "Suscribirme · 5 $ / mes",
      redirecting: "Redirigiendo…",
    },
    library: {
      shortsEmpty: "Shorts que guardaste y tus listas",
      saved: "{n} guardados",
      playlists: "{n} lista | {n} listas",
      memoriesEmpty: "Tus propias historias, guardadas después de 24 horas",
      memories: "{n} recuerdo | {n} recuerdos",
      freeSaves: "{used} de {limit} guardados gratis usados",
    },
    muzilly: {
      connectedAs: "Conectado como {name}",
      yourAccount: "tu cuenta de Muzilly",
      yourAccountTitle: "Tu cuenta de Muzilly",
      connectPrompt: "Artistas y oyentes: conecta tu cuenta",
      connected: "● Conectado",
      linkedBody: "{name}: si eres artista, lo que publicas aquí de forma pública aparece en tu página de Muzilly. Si eres oyente, las canciones que escuchas aquí cuentan para los artistas que sigues.",
      intro: "Artistas: tus publicaciones públicas aparecen en tu página de Muzilly. Oyentes: las canciones que escuchas aquí cuentan para los artistas que sigues.",
      step1: "Abre Muzilly y ve a tu perfil.",
      step2: "Toca Conectar Tribzz para obtener un código de 8 caracteres.",
      step3: "Escríbelo abajo; funciona durante 10 minutos.",
      codeLabel: "Código de Muzilly",
      close: "Cerrar",
      cancel: "Cancelar",
      disconnect: "Desconectar",
      working: "Procesando…",
      connect: "Conectar",
      connecting: "Conectando…",
      errConnect: "No se pudo conectar. Prueba con un código nuevo.",
      errDisconnect: "No se pudo desconectar.",
    },
    signOut: "Cerrar sesión",
    deleteAccount: "Eliminar cuenta",
    deleteWarning: "Eliminar tu cuenta es permanente e inmediato. Tus publicaciones, mensajes, check-ins y conexiones se borran al instante, y no se puede deshacer.",
    deleteButton: "Eliminar mi cuenta…",
    deleteTitle: "¿Eliminar tu cuenta?",
    deleteText: "Esto borra de forma permanente e inmediata tu perfil, publicaciones, mensajes y conexiones. No se puede deshacer.",
    typeDelete: "Escribe DELETE para confirmar",
    cancel: "Cancelar",
    deleting: "Eliminando…",
    deleteForever: "Eliminar para siempre",
  },

  home: {
    notifications: "Notificaciones",
    overline: "La plataforma de la gente · {date}",
    welcome: "◆ Hola de nuevo, {name} ◆",
    welcomeAnon: "◆ Hola de nuevo ◆",
    deck: "Tus círculos, tu cultura: todo lo de abajo es solo la portada de hoy.",
    news: {
      label: "Noticias Tribzz",
      all: "Todas las noticias →",
      listenTop: "Escuchar la noticia principal",
      listenLatest: "Escuchar lo último · {n} noticias",
      topStory: "★ NOTICIA PRINCIPAL",
      newsroom: "· Redacción Tribzz",
      read: "Leer la noticia →",
      minRead: "{n} min de lectura",
      listen: "🎧 Escuchar",
    },
    topics: {
      local: "📍 Local",
      politics: "🗳 Política",
      government: "🏛 Gobierno",
      crime: "⚖️ Sucesos y tribunales",
      business: "💼 Negocios",
      education: "🎓 Educación",
      health: "🩺 Salud",
      sports: "🏀 Deportes",
      culture: "🎨 Cultura",
      tech: "💻 Tecnología",
      environment: "🌱 Medio ambiente",
      community: "🤝 Comunidad",
      news: "📰 Noticias",
    },
    ago: {
      minutes: "hace {n} min",
      hours: "hace {n} h",
      days: "hace {n} d",
    },
    share: "Comparte algo",
    watch: {
      label: "Mira y crea",
      browseChannels: "Ver canales",
      startChannel: "Crear un canal",
      watchShorts: "Ver shorts",
      browseStores: "Ver tiendas",
      launchStore: "Abrir una tienda",
    },
    explore: {
      label: "Desde Explorar",
      headLine1: "De qué se habla",
      headLine2: "ahora mismo",
      intro: "Explorar es donde de verdad pasa la cultura. Un vistazo rápido a la portada de hoy; el resto está a un toque.",
      loading: "Preparando la edición de hoy…",
      house: "◆ Tribzz Daily",
      aMember: "Un miembro",
      inGroup: "en {name}",
      readOn: "Leer en Explorar →",
      emptyTitle: "La portada está en blanco.",
      emptySub: "Nadie ha publicado en las últimas 24 horas. Sé el primero.",
      enter: "Entrar a Explorar",
      vanishing: "Desaparece pronto",
      hoursLeft: "Quedan {n} h",
    },
    live: {
      label: "Ahora mismo",
      headA: "Tribzz públicos",
      headLive: "en directo",
      headB: "ahora",
      intro: "Abiertos a todos: entra y mira, aunque todavía no te hayas unido.",
      badge: "● EN DIRECTO",
    },
    circles: {
      label: "Tus círculos",
      headA: "Quién está",
      headLive: "en directo",
      headB: "ahora mismo",
      intro: "Cada Tribzz es su propio espacio, dirigido por quien lo creó. Aquí ves quién está en directo y quién ha hecho check-in en este momento.",
      loading: "Viendo quién anda por aquí…",
      hereNow: "{n} aquí ahora",
      nobody: "Nadie ha hecho check-in todavía",
      emptyTitle: "Aún no te has unido a ningún Tribzz.",
      emptySub: "Un restaurante, un equipo, una persona: cualquiera puede crear uno. Encuentra el tuyo o créalo.",
      browse: "Ver Tribzz",
      start: "Crea el tuyo",
    },
    people: {
      label: "Tu círculo",
      headA: "Personas para",
      headB: "conectar",
      intro: "Tribzz en común, la misma ciudad, los mismos intereses: tengan lo que tengan en común, lo encontramos.",
      loading: "Buscando a tu gente…",
      activeNow: "En línea ahora",
      member: "Miembro",
      inGroup: "En {name} contigo",
      alsoInto: "También le gusta {interest}",
      view: "Ver perfil",
      connected: "Conectados ✓",
      connect: "Conectar",
      emptyTitle: "No hay sugerencias por ahora.",
      emptySub: "Agrega tus intereses o tu ubicación en Información personal, o únete a un Tribzz; cualquiera de estas cosas nos ayuda a encontrar a tu gente.",
    },
    connections: {
      headA: "Mis",
      headB: "conexiones",
      loading: "Cargando tus conexiones…",
      emptyTitle: "Aún no tienes conexiones.",
      emptySub: "Conecta con personas de arriba y aparecerán aquí.",
    },
  },

  categories: {
    moment: "Momento",
    here_now: "Aquí ahora",
    ask: "Pregunta",
    poll: "Encuesta",
    mood: "Estado de ánimo",
    travel_plan: "Plan de viaje",
    music: "Música",
  },

  daily: {
    question: "Pregunta del día",
    poll: "Encuesta",
    wyr: "¿Qué prefieres?",
    quote: "Cita",
    trivia: "Trivia",
    fact: "¿Sabías que…?",
    riddle: "Acertijo",
    history: "Un día como hoy",
    recipe: "Receta rápida",
    diy: "Cómo se hace",
  },
};